export const copyToClipboard = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
        // Сучасний метод (працює у Chrome, Firefox, Edge, Safari 13+)
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {
            return false;
        }
        
    } else { 
        // Альтернативний метод для Safari < 13 і старих браузерів
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "absolute";
        textArea.style.left = "-9999px";
        textArea.style.display = "none";
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand("copy");
            return true;
        } catch (err) {
            console.error("Fallback copy failed:", err);
            return false;
        } 
        finally {
            document.body.removeChild(textArea);
        }
        
    }
     
}
